import { render } from "./addNews.vue?vue&type=template&id=2d454646&scoped=true"
import script from "./addNews.vue?vue&type=script&lang=js"
export * from "./addNews.vue?vue&type=script&lang=js"

import "./addNews.vue?vue&type=style&index=0&id=2d454646&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d454646"]])

export default __exports__